<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      class="custom-el-wrapper"
      width="600px"
      @close="handlerCancel"
  >
    <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
      <template v-if="viewMode !== 'readonly'">
        <el-form-item label="地址信息">
          <el-input type="textarea" v-model="address_text" placeholder="粘贴地址信息，点击智能识别按钮自动识别填充地址信息" clearable></el-input>
          <el-button size="mini" @click="bindExplainAddress">智能识别</el-button>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input v-model="form.name" placeholder="请输入收件人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" placeholder="请输入收件人手机号"></el-input>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader
              :key="platform === 'wx' ? 'wx-cascader-' + wxCascaderKey : 'dd-cascader'"
              placeholder="请输入省市区"
              size="large"
              style="width: 100%;"
              :options="platform === 'wx' ? wxRegionOptions : regionData"
              v-model="selectedOptions"
              :props="cascaderProps"
              @change="areaChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="form.detail" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="原始地址" v-if="original_address">
          <span>{{ original_address }}</span>
        </el-form-item>
      </template>
      <el-form-item v-else label="原始地址">
        <span>{{ original_address || '暂无原始地址' }}</span>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">{{ viewMode === 'readonly' ? '关 闭' : '取 消' }}</el-button>
      <el-button v-if="viewMode !== 'readonly'" type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { MSG_RETURN_ADDRESS_SAVE_TIP } from '@/constants/wxReturnAddressTips'

export default {
  data() {
    return {
      platform: 'dd',
      address_text: '',
      original_address: '',
      canSave: 1,
      form:{
        dd_order_id:'',
        order_product_id:'',
        alibaba_order_id:'',
        province_id:'',
        city_id:'',
        town_id:'',
        street_id:'',
        detail:'',
        name:'',
        phone:'',
      },
      regionData: [],
      wxRegionOptions: [],
      wxCascaderKey: 0,
      ddRegionProps:{
        value:'id',
        label:'label'
      },
      selectedOptions: [],
      visible: false,
      callback: null,
      title: '',
      loading: true,
      viewMode: 'edit',
    }
  },
  computed: {
    cascaderProps() {
      if (this.platform === 'wx') {
        return {
          value: 'code',
          label: 'name',
          lazy: true,
          lazyLoad: this.loadWxRegionNode,
        }
      }
      return this.ddRegionProps
    },
  },
  methods: {
    ...mapActions({
      getRegionData:"ucenter_order/getRegionData",
      getDdReturnAddressInfo:"ucenter_order/getDdReturnAddressInfo",
      opEditDdReturnAddress:"ucenter_order/opEditDdReturnAddress",
      getExplainAddress: "ucenter_order/getExplainAddress",
      getWxReturnAddressAction: "wxshopOrder/getReturnAddressAction",
      postWxReturnAddressAction: "wxshopOrder/postReturnAddressAction",
      postWxExplainAddressAction: "wxshopOrder/postExplainAddressAction",
      getAddressCodeChildrenAction: "wxshopOrder/getAddressCodeChildrenAction",
    }),
    open(title, orderKey, callback, options = {}) {
      this.title = title;
      this.platform = options.platform === 'wx' ? 'wx' : 'dd';
      this.address_text = '';
      this.original_address = '';
      this.canSave = 1;
      this.form.dd_order_id = this.platform === 'dd' ? orderKey : '';
      this.form.order_product_id = this.platform === 'wx' ? String(orderKey || options.order_product_id || '') : '';
      this.form.alibaba_order_id = String(options.alibaba_order_id || '').trim();
      this.viewMode = options.readonly ? 'readonly' : 'edit';
      this.callback = callback;
      this.wxRegionOptions = [];
      this.wxCascaderKey = 0;
      this.selectedOptions = [];
      if (this.viewMode !== 'readonly') {
        this.initRegionData()
      }
      this.initAddressInfo()
      this.visible = true;
    },
    initRegionData(){
      if (this.platform === 'wx') {
        if (this.viewMode !== 'readonly') {
          this.loading = false
        }
        return
      }
      var params = {}
      this.loading = true
      this.getRegionData({data:params,success:(res)=>{
          if(res.code===200){
            this.regionData = res.data
            if (this.viewMode !== 'readonly') {
              this.loading = false
            }
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
        }})
    },
    fetchWxRegionChildren(parentCode) {
      return new Promise((resolve, reject) => {
        this.getAddressCodeChildrenAction({
          data: { parent_code: Number(parentCode) || 0 },
          success: (res) => {
            if (res.code !== 200) {
              reject(new Error(res.msg || '获取行政区失败'))
              return
            }
            const list = Array.isArray(res.data && res.data.list) ? res.data.list : []
            resolve(list.map((row) => ({
              code: Number(row.code),
              name: row.name,
              leaf: Number(row.level) >= 3,
            })))
          },
          error: () => reject(new Error('获取行政区失败')),
        })
      })
    },
    /**
     * 懒加载级联需预填选中路径上的节点，否则 v-model 有值但界面不显示文案
     */
    applyWxRegionSelection(provinceId, cityId, townId) {
      const p = Number(provinceId) || 0
      const c = Number(cityId) || 0
      const t = Number(townId) || 0
      if (!p) {
        this.wxRegionOptions = []
        this.selectedOptions = []
        this.wxCascaderKey += 1
        return Promise.resolve()
      }
      return this.fetchWxRegionChildren(0).then((provinces) => {
        provinces.forEach((node) => {
          node.leaf = false
        })
        const provinceNode = provinces.find((node) => Number(node.code) === p)
        if (!provinceNode) {
          this.wxRegionOptions = provinces
          this.selectedOptions = [p, c, t].filter((v) => v > 0)
          this.wxCascaderKey += 1
          return
        }
        let chain = Promise.resolve()
        if (c) {
          chain = this.fetchWxRegionChildren(p).then((cities) => {
            cities.forEach((node) => {
              node.leaf = false
            })
            provinceNode.children = cities
            const cityNode = cities.find((node) => Number(node.code) === c)
            if (cityNode && t) {
              return this.fetchWxRegionChildren(c).then((counties) => {
                counties.forEach((node) => {
                  node.leaf = true
                })
                cityNode.children = counties
              })
            }
          })
        }
        return chain.then(() => {
          this.wxRegionOptions = provinces
          this.selectedOptions = [p, c, t].filter((v) => v > 0)
          this.wxCascaderKey += 1
        })
      }).catch(() => {
        this.selectedOptions = [p, c, t].filter((v) => v > 0)
        this.wxCascaderKey += 1
      })
    },
    loadWxRegionNode(node, resolve) {
      const parentCode = node.root ? 0 : Number(node.value || 0)
      this.fetchWxRegionChildren(parentCode).then((nodes) => {
        resolve(nodes)
      }).catch(() => resolve([]))
    },
    initAddressInfo(){
      if (this.platform === 'wx') {
        this.initWxAddressInfo()
        return
      }
      var params = {
        dd_order_id: this.form.dd_order_id
      }
      if (this.form.alibaba_order_id) {
        params.alibaba_order_id = this.form.alibaba_order_id
      }
      this.loading = true
      this.getDdReturnAddressInfo({data:params,success:(res)=>{
          this.loading = false
          if(res.code===200){
            const data = res.data || {}
            if (data.view_mode === 'readonly' || Number(data.readonly) === 1) {
              this.viewMode = 'readonly'
              this.original_address = data.address_text || data.origin_detail || ''
              return
            }
            if(data.id){
              const str_dd_order_id = this.form.dd_order_id;
              const aliOid = this.form.alibaba_order_id;
              this.form = data
              this.form.dd_order_id = str_dd_order_id;
              this.form.alibaba_order_id = aliOid;
              this.selectedOptions = [this.form.province_id,this.form.city_id,this.form.town_id,this.form.street_id]
              this.original_address = data.address_text
            }else{
              this.resetEmptyForm('dd')
            }

          } else {
            this.$message({message: res.msg,type: 'error'})
          }
        }})
    },
    initWxAddressInfo() {
      const params = {
        order_product_id: this.form.order_product_id,
        alibaba_order_id: this.form.alibaba_order_id,
      }
      this.loading = true
      this.getWxReturnAddressAction({
        data: params,
        success: (res) => {
          if (res.code !== 200) {
            this.loading = false
            this.$message({ message: res.msg, type: 'error' })
            return
          }
          const data = res.data || {}
          if (data.view_mode === 'readonly' || Number(data.readonly) === 1) {
            this.loading = false
            this.viewMode = 'readonly'
            this.original_address = data.address_text || data.origin_detail || ''
            return
          }
          this.canSave = Number(data.can_save ?? 1)
          const opId = this.form.order_product_id
          const aliOid = this.form.alibaba_order_id
          if (data.id || data.name || data.phone || data.detail) {
            this.form = {
              ...this.form,
              ...data,
              order_product_id: opId,
              alibaba_order_id: aliOid,
              street_id: Number(data.street_id || 0),
              province_id: Number(data.province_id || 0),
              city_id: Number(data.city_id || 0),
              town_id: Number(data.town_id || 0),
            }
            this.original_address = data.address_text || data.origin_detail || ''
            this.loading = true
            this.applyWxRegionSelection(
              this.form.province_id,
              this.form.city_id,
              this.form.town_id,
            ).finally(() => {
              this.loading = false
            })
          } else {
            this.resetEmptyForm('wx')
            this.loading = false
          }
        },
      })
    },
    resetEmptyForm(platform) {
      const opId = this.form.order_product_id
      const ddId = this.form.dd_order_id
      const aliOid = this.form.alibaba_order_id
      this.form = {
        dd_order_id: platform === 'dd' ? ddId : '',
        order_product_id: platform === 'wx' ? opId : '',
        alibaba_order_id: aliOid,
        province_id:'',
        city_id:'',
        town_id:'',
        street_id:'',
        detail:'',
        name:'',
        phone:'',
      }
      this.selectedOptions = []
      this.wxRegionOptions = []
      this.wxCascaderKey += 1
      this.original_address = ''
    },
    bindExplainAddress(){
      if(!this.address_text){
        this.$message({message: '请输入地址信息',type: 'error'})
        return;
      }
      this.loading = true
      if (this.platform === 'wx') {
        this.postWxExplainAddressAction({
          data: { address_text: this.address_text },
          success: (res) => {
            if (res.code !== 200) {
              this.loading = false
              this.$message({ message: res.msg, type: 'error' })
              return
            }
            const d = res.data || {}
            const codes = Array.isArray(d.region_codes) ? d.region_codes : []
            this.form.name = d.user_name || ''
            this.form.phone = d.tel_number || ''
            this.form.detail = d.detail_info || ''
            this.form.province_id = codes[0] || 0
            this.form.city_id = codes[1] || 0
            this.form.town_id = codes[2] || 0
            this.form.street_id = 0
            this.applyWxRegionSelection(
              this.form.province_id,
              this.form.city_id,
              this.form.town_id,
            ).finally(() => {
              this.loading = false
            })
          },
        })
        return
      }
      var params = {
        address_text: this.address_text
      }
      this.getExplainAddress({data:params,success:(res)=>{
          this.loading = false;
          if(res.code===200){
            const str_dd_order_id = this.form.dd_order_id;
            const aliOid = this.form.alibaba_order_id;
            this.form = res.data
            this.form.dd_order_id = str_dd_order_id;
            this.form.alibaba_order_id = aliOid;
            this.selectedOptions = [this.form.province_id,this.form.city_id,this.form.town_id,this.form.street_id]
          } else {
            this.$message({message: res.msg,type: 'error'})
          }
        }})
    },
    areaChange(value) {
      if (this.platform === 'wx') {
        this.form.province_id = value[0] || 0
        this.form.city_id = value[1] || 0
        this.form.town_id = value[2] || 0
        this.form.street_id = 0
        return
      }
      this.form.province_id = value[0]
      this.form.city_id = value[1]
      this.form.town_id = value[2]
      this.form.street_id = value[3]
    },
    doSave() {
      if(this.loading) return;
      this.loading = true
      if (this.platform === 'wx') {
        const payload = {
          order_product_id: Number(this.form.order_product_id),
          alibaba_order_id: this.form.alibaba_order_id,
          name: this.form.name,
          phone: this.form.phone,
          province_id: Number(this.form.province_id),
          city_id: Number(this.form.city_id),
          town_id: Number(this.form.town_id),
          street_id: Number(this.form.street_id || 0),
          detail: this.form.detail,
        }
        this.postWxReturnAddressAction({
          data: payload,
          success: (res) => {
            this.loading = false
            if (res.code === 200) {
              this.$message({ message: res.msg || '修改成功', type: 'success' })
              this.callback && this.callback();
              this.visible = false;
            } else {
              this.$message({ message: res.msg, type: 'error' })
            }
          },
        })
        return
      }
      this.opEditDdReturnAddress({data:this.form,success:(res)=>{
          this.loading = false
          if(res.code===200){
            this.$message({message: res.msg,type: 'success'})
            this.callback && this.callback();
            this.visible = false;
          } else {
            this.$message({message: res.msg,type: 'error'})
          }
        }})
    },
    handlerConfirm() {
      if (this.platform === 'wx' && Number(this.canSave) !== 1) {
        this.$message({ message: '当前状态不可保存', type: 'warning' })
        return
      }
      const confirmMsg = this.platform === 'wx' ? MSG_RETURN_ADDRESS_SAVE_TIP : null
      if (confirmMsg) {
        this.$confirm(confirmMsg, '提示', { type: 'warning' }).then(() => {
          this.doSave()
        }).catch(() => {})
        return
      }
      this.doSave()
    },
    handlerCancel() {
      this.visible = false;
      this.$emit('close', {})
    },
  }
}
</script>

<style scoped>

</style>
